/**
 * コスト上限関連 Zod スキーマ
 *
 * 月額 API コスト上限の設定・ステータス・管理に関するバリデーションスキーマ。
 * 型定義は z.infer で自動生成し、Single Source of Truth とする。
 */
import { z } from 'zod';
// ========================================
// コスト上限ドメインスキーマ
// ========================================
/**
 * コスト上限値バリデーション（USD 単位、0 以上、小数点以下 2 桁まで）
 */
export const CostLimitUSDSchema = z.number().min(0).multipleOf(0.01);
/**
 * コスト上限設定
 */
export const CostLimitSettingSchema = z.object({
    limitUSD: CostLimitUSDSchema,
    updatedAt: z.string(), // ISO 8601
    updatedBy: z.string(), // admin email
});
/**
 * ユーザー別コスト上限エントリ
 */
export const UserCostLimitEntrySchema = z.object({
    email: z.string(),
    setting: CostLimitSettingSchema,
});
/**
 * コスト上限チェック結果
 */
export const CostLimitCheckResultSchema = z.object({
    allowed: z.boolean(),
    currentCost: z.number(),
    limit: z.number().nullable(), // null = 制限なし
    remaining: z.number().nullable(), // null = 制限なし
    usagePercent: z.number().nullable(), // null = 制限なし
});
/**
 * 使用量期間
 */
export const CostLimitPeriodSchema = z.object({
    year: z.number(),
    month: z.number(),
});
// ========================================
// コスト上限 API レスポンススキーマ
// ========================================
/**
 * GET /cost-limit/status レスポンス
 */
export const CostLimitStatusResponseSchema = z.object({
    currentCost: z.number(),
    limit: z.number().nullable(),
    remaining: z.number().nullable(),
    usagePercent: z.number().nullable(),
    period: CostLimitPeriodSchema,
    isDefault: z.boolean(),
});
/**
 * GET /admin/cost-limits レスポンス
 */
export const CostLimitsListResponseSchema = z.object({
    defaultLimit: CostLimitSettingSchema.nullable(),
    userLimits: z.array(UserCostLimitEntrySchema),
});
/**
 * GET /admin/cost-limits/users/:email レスポンス
 */
export const UserCostLimitDetailResponseSchema = z.object({
    email: z.string(),
    effectiveLimit: z.number().nullable(),
    userLimit: CostLimitSettingSchema.nullable(),
    defaultLimit: CostLimitSettingSchema.nullable(),
    currentCost: z.number(),
    usagePercent: z.number().nullable(),
    period: CostLimitPeriodSchema,
});
// ========================================
// コスト上限 API リクエストスキーマ
// ========================================
/**
 * PUT /admin/cost-limits/default, PUT /admin/cost-limits/users/:email リクエスト
 */
export const SetCostLimitRequestSchema = z.object({
    limitUSD: CostLimitUSDSchema,
});
//# sourceMappingURL=cost-limit-schemas.js.map